import React from 'react'
import { cn } from '@/common/lib/cn/cn'
import { icons, IconName } from './icons'

export type IconProps = {
    name: IconName
    className?: string
    size?: 'sm' | 'md' | 'lg' | 'xl'
} & React.SVGProps<SVGSVGElement>

export type { IconName }

export const Icon = ({ name, className = '', size = 'md', ...props }: IconProps) => {
    const IconComponent = icons[name]

    if (!IconComponent) {
        console.warn(`Icon "${name}" not found`)
        return null
    }

    const sizeClasses = cn(
        'fill-current',
        {
            'w-4 h-4': size === 'sm',
            'w-5 h-5': size === 'md',
            'w-6 h-6': size === 'lg',
            'w-7 h-7': size === 'xl',
        },
        className
    )

    return <IconComponent className={sizeClasses} {...props} />
}
